export default "__VITE_ASSET__Dc8mnzME__"